export function extractInputBuilderProps(props) {
  const {
    left,
    size,
    loadingState,
    leadingText,
    ...restProps
  } = props;
  const inputBuilderProps = {
    left,
    size: size ?? "m",
    loadingState,
    leadingText
  };
  const filteredInputBuilderProps = Object.keys(inputBuilderProps).reduce((acc, key) => {
    if (inputBuilderProps[key] !== undefined) {
      // @ts-expect-error We need to filter out undefined values, so that we can set that default in the component that uses it.
      acc[key] = inputBuilderProps[key];
    }
    return acc;
  }, {});
  return {
    inputBuilderProps: filteredInputBuilderProps,
    restProps
  };
}
//# sourceMappingURL=inputBuilderHelper.js.map